import { server_connection } from 'config';
import { GET_ASSIGNMENT } from './assignment.actions';
import * as NotificationActions from '../../../notification/store/actions';
import * as DashboardActions from '../../../dashboard/store/actions';
import store from 'store';
import { updateUserRoles } from '../../../../../auth/store/actions';

import history from 'history.js';

export const GET_STUDENT_ASSIGNMENT = '[STUDENT_ASSIGNMENT_APP] GET STUDENT ASSIGNMENT';
export const GET_STUDENT_INFO = '[STUDENT_ASSIGNMENT_APP] GET STUDENT INFO';
export const UPDATE_STUDENT_ASSIGNMENT = '[STUDENT_ASSIGNMENT_APP] UPDATE STUDENT ASSIGNMENT';
export const GET_NEXT_EVENT_FOR_CONTINUE = '[STUDENT_ASSIGNMENT_APP] GET NEXT EVENT FOR CONTINUE';

export function getStudentAssignment(student_assignment_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/assignment/student/get/' + student_assignment_id)
            .then((response) => response.json())
            .then((responseData) => {
                return dispatch({
                    type: GET_STUDENT_ASSIGNMENT,
                    payload: responseData
                });
            });
    }
}

// Pulls Assignment/Student_Assignment info // Will create a blank student_assignment record if one doesn't exist on page load
export function getAssignmentByEventID(calendar_event_id, auth_id) {
    return (dispatch) => {
        fetch(server_connection + '/assignment/student/get_by_event/',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ calendar_event_id, auth_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                const { assignment, student_assignment, redirect } = responseData;

                if (redirect) {
                    history.push('/dashboard')
                }
                else {
                    dispatch({
                        type: GET_ASSIGNMENT,
                        payload: assignment,
                    });

                    dispatch({
                        type: GET_STUDENT_ASSIGNMENT,
                        payload: student_assignment,
                    });
                }

            });
    }
}

// Pulls Assignment/Student_Assignment info // Will create a blank student_assignment record if one doesn't exist on page load
export function getAssignmentByStudentAssignmentID(student_assignment_id) {
    return (dispatch) => {
        fetch(server_connection + '/assignment/student/get_by_student_assignment/',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ student_assignment_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                const { assignment, student_assignment, student_info } = responseData;

                dispatch({
                    type: GET_ASSIGNMENT,
                    payload: assignment,
                });

                dispatch({
                    type: GET_STUDENT_ASSIGNMENT,
                    payload: student_assignment,
                });

                dispatch({
                    type: GET_STUDENT_INFO,
                    payload: student_info
                })
            });
    }
}

export function updateStudentAssignment(update_data) {
    return (dispatch) => {
        return dispatch({
            type: UPDATE_STUDENT_ASSIGNMENT,
            payload: update_data
        })
    }
}

export function gradeStudentAssignment(student_assignment_header, auth_id, goBack = false) {
    return (dispatch) => {
        fetch(server_connection + '/assignment/student/grade/',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ student_assignment_header, auth_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                if (goBack) {
                    history.goBack();
                }
            });
    }
}

export function deleteStudentAssignmentAsset(student_assignment_id) {
    return (dispatch) => {
        fetch(server_connection + '/assignment/student/asset/set_submission_date',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ student_assignment_id, reset: true })
            })
            .then((response) => {
                dispatch(getAssignmentByStudentAssignmentID(student_assignment_id));
            });
    }
}

export function addStudentAssignmentAsset(student_assignment_id) {
    return (dispatch) => {
        fetch(server_connection + '/assignment/student/asset/set_submission_date',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ student_assignment_id, reset: false })
            })
            .then((response) => {
                dispatch(getAssignmentByStudentAssignmentID(student_assignment_id));
                dispatch(NotificationActions.getNotifications(store.getState().auth.user));
                dispatch(updateUserRoles(store.getState().auth.user.data.auth_id));
            });
    }
}

export function submitNonGradedAssignment(student_assignment, TotalScore) {
    return (dispatch) => {
        const assignment = student_assignment.header;
        fetch(server_connection + '/assignment/submit/non-graded-assignment',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ student_assignment: assignment, TotalScore })
            })
            .then((response) => {
                dispatch(DashboardActions.getCourseEvents(assignment.company_calendar_course_id, assignment.student_id, assignment.CourseUnscheduled));
                dispatch(NotificationActions.getNotifications(store.getState().auth.user));
                dispatch(updateUserRoles(store.getState().auth.user.data.auth_id))
            });
    }
}

export function getNextEventForContinueButton(cur_event_id, student_id) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/scheduled_course/next_course_event_for_continue/' + cur_event_id + '/' + 0 + '/' + student_id)
            .then((response) => response.json())
            .then((responseData) => {
                return dispatch({
                    type: GET_NEXT_EVENT_FOR_CONTINUE,
                    payload: responseData
                });
            });
    }
}



// WEBPACK FOOTER //
// src/main/content/assignment/store/actions/student_assignment.actions.js